module.exports = __webpack_public_path__ + "img/feedback.90edbcd1.svg";